/*eslint-disable*/
import { useState } from "react";
import styled from '@emotion/styled';

import {
    Alert,
} from 'reactstrap';

const ToasterWrapper = styled.div`
`;

const toastStyle = {
    position: 'fixed',
    bottom: 20,
    right: 20,
};

const Toaster = ({
    color,
    alertText
}) => {
    const [visible, setVisible] = useState(true);

    const onDismiss = () => setVisible(false);

    return (
        <ToasterWrapper>
            <Alert style={toastStyle} color={color} isOpen={visible} toggle={onDismiss}>
                {alertText}
            </Alert>
        </ToasterWrapper>
    );
};

export default Toaster;
